export default "__VITE_ASSET__DKx3GD_3__"